
/* injects from baggage-loader */

'use strict';

/**
 * Constants definition for the environment associated to 'production'.
 */
const productionConstant = {
	MSG_ERROR: 'Ocurrió un error inesperado inténtelo más tarde.',
	MSG_TOKEN_EXPIRED: 'Se perdió tu sesión, por favor intenta autenticarte nuevamente.',
	STORAGE: {
		AUTHENTICATED: 'userGana',
		KEY: '$3cr3tSe$$!0nK3y$t0r@g3',
		TOKEN: {
			HEADER: 'Authorization_gana',
			NAME: 'tkn',
			PREFIX: 'gana',
			TYPE: 'auth_Gana'
		},
		TYPE: 'localStorage',
		USER: 'uGana',
	},
	TITLE: 'Raspita | ',
	URL_ENDPOINT: 'http://raspita.gana.com.co/raspa/services',
	URL_ENDPOINT_GANA: 'http://raspita.gana.com.co/raspa/services',
	URL_ENDPOINT_PUBLIC: 'http://raspita.gana.com.co/raspa/public',
};

export default productionConstant;



// WEBPACK FOOTER //
// ./src/app/core/constants/production.constants.js